import { Card, CardHeader, CardFooter, Heading, Box } from '@chakra-ui/react';
import { EditDataIcon } from '../iconButtons/EditDataIcon';
import { RemoveItem } from '../iconButtons/RemoveItem';

interface IProps {
  'data-selector'?: string;
  id?: string;
  label: string;
  value: React.ReactNode;
  hasEdit?: boolean;
  onEditClick?: () => void;
  hasClose?: boolean;
  onCloseClick?: () => void;
}

export const CostItem = (props: IProps) => {
  const { id, label, value, hasEdit, onEditClick, hasClose, onCloseClick, 'data-selector': dataSelector } = props;

  const dataId = id || 'cost-item';

  return (
    <Card variant="outline" flexDirection="row" borderRadius="lg" mb={3} data-selector={dataSelector}>
      <CardHeader
        data-selector={`${dataId}-label`}
        display="flex"
        flexDirection={{ base: 'column', lg: 'row' }}
        flexGrow="1"
        pr={{ base: 2, lg: 4 }}
      >
        <Heading as="h3" fontSize="md" fontWeight="medium" lineHeight={6} flexGrow="1">
          {label}
        </Heading>

        <Box data-selector={`${dataId}-value`} lineHeight={6}>
          {value}
        </Box>
      </CardHeader>

      <CardFooter textAlign={{ base: 'initial', lg: 'right' }} width="calc(40px + 40px + 16px)" pl={0} pr={4} py={3}>
        {hasEdit ? <EditDataIcon type="unclicked" id={dataId} onClick={onEditClick} variant="ghost" size="md" /> : null}

        {hasClose ? (
          <RemoveItem data-selector={`${dataId}-close`} onClick={onCloseClick} variant="ghost" size="md" />
        ) : null}
      </CardFooter>
    </Card>
  );
};
